import React, { useEffect, useState } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "../battery/AddBattery.module.scss";
import { Link } from "react-router-dom";

import notificationService from "services/notification.service";
import { useHistory } from "react-router-dom";
// import { postRequest } from "services/axiosBaseClient.pricing";
import { postRequest } from "services/axiosBaseClient";
var action = "Submit";

function AddPriceList(props) {
  const table = localStorage.getItem("table title");
  // console.log(`table is ${table}`);

  const initialFormValues = {
    priceName: "",
    price: "",
    // status: -1,
    // priceCurrency:"INR"
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  // const [isSubmit, setIsSubmit] = useState(false);
  const history = useHistory();

  // const handleSelectChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormValues({ ...formValues, [name]: value });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    setFormValues({
      ...formValues,
      [name]:
        name === "price"
          ? value.replace(/[^\d.]/g, "").replace(/^(\d*\.\d{0,2})\d*/, "$1")
          : value,
    });

    // if(name === 'price'){
    //   e.target.validity.valid ? setFormValues({...formValues, price:value}): setFormValues({...formValues, price:0})
    // }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues);

    if (Object.values(result).every((x) => x === "")) {
      if (action === "Submit") {
        const payload = {
          // "isActive": formValues.status,
          name: formValues.priceName,
          price: formValues.price,
          // "priceCurrency": formValues.priceCurrency,
        };
        try {
          postRequest("bss/addPrice", payload)
            .then((res) => {
              if (res && res.error == false) {
                history.push({
                  pathname: "/Pricing",
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.message
                );
              } else {
                notificationService.showNonBlacklistedError(
                  res?.config?.url,
                  res?.message
                );
              }
            })
            .catch((error) => {
              console.log(error, "ERROR");
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.message
              );
              return error;
            });
        } catch (error) {
          console.log(error);
        }
      }
      // if (action === "Update") {
      // try {
      //   const payload = {
      //     priceName: formValues.priceName,
      //     price: formValues.price,
      //     status: formValues.status,
      //   }
      //   putRequest("enterprise/update", payload).then((res) => {
      //     if (res && res?.data) {
      //       // history.push("/price");
      //       console.log("update")
      //     }
      //   }).catch((error) => {
      //     notificationService.showNonBlacklistedError(error?.config?.url, error?.response?.data?.message);
      //   });
      // } catch (error) {
      //   console.log(error);
      // }
      // }
    }
  };

  const validate = (formValues) => {
    const errors = {};
    // const rx = /^[+-]?\d+(\.\d+)?$/;

    if (!formValues.priceName || formValues.priceName === "0") {
      errors.priceName = "Price Name is required!";
    } else if (!/^[ A-Za-z0-9/_,\( \)-]*$/i.test(formValues.priceName)) {
      errors.priceName = "_ ,(  )- are the only allowed special characters!";
    } else {
      errors.priceName = "";
    }

    if (!formValues.price || formValues.price === "0") {
      errors.price = "Price is required!";
    } else if (formValues.price == -1) {
      errors.priceName = "Please enter a valid price name!";
    } else {
      errors.price = "";
    }

    // if (formValues.status == -1) {
    //   errors.status = "Status is required!";
    // }
    // else {
    //   errors.status = "";
    // }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
    setFormErrors("");
  };
  return (
    <>
      <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
        {"Price"}
      </h2>

      <div
        className={cn(styles.group, styles.group_layout)}
        style={{ borderRadius: "10px", margin: "20px 10px" }}
      >
        <form>
          <div className={cn(styles.flex3, styles.flex3_layout)}>
            <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
              {"Add Price"}
            </h3>
            <hr className={cn(styles.line, styles.line_layout)} />

            <div className={cn(styles.flex2, styles.flex2_layout)}>
              <div className={cn(styles.flex2_item)}>
                <div className={cn(styles.block3, styles.block3_layout)}>
                  <div
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Price Name*"}
                  </div>
                  {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                  <input
                    type="text"
                    name="priceName"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.priceName}
                    maxLength="50"
                    onChange={handleChange}
                  />
                </div>
                <p className={cn(styles.error)}>{formErrors.priceName}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div className={cn(styles.flex2_item)}>
                <div className={cn(styles.block3, styles.block3_layout)}>
                  <div
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Price (In INR)*"}
                  </div>
                  <input
                    type="text"
                    name="price"
                    // pattern="[0-9]*"
                    maxLength={15}
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.price}
                    onChange={handleChange}
                  />
                </div>
                <p className={cn(styles.error)}>{formErrors.price}</p>
              </div>
            </div>

            {/* <div className={cn(styles.flex2, styles.flex2_layout)}>
              <div className={cn(styles.flex2_item)}>
                <div className={cn(styles.block3, styles.block3_layout)}>
                  <div
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Status"}
                  </div>
                  <select
                  name ="status"
                    value={formValues.status}
                    className={cn(styles.line1, styles.line1_layout)}
                    onChange={handleSelectChange}
                  >
                    <option value="-1" selected>Select Status</option>
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                  </select>
                </div>
                <p className={cn(styles.error)}>{formErrors.status}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div className={cn(styles.flex2_item)}></div>
            </div> */}

            <div className={cn(styles.flex2, styles.flex2_layout)}>
              <div className={cn(styles.flex2_item)}></div>
              <div className={cn(styles.flex2_spacer)} />
              <div className={cn(styles.flex2_item)}></div>
            </div>

            <div className={cn(styles.flex9, styles.flex9_layout)}>
              <div className={cn(styles.flex9_item)}>
                <Link to="/Pricing">
                  <div
                    onClick={reset}
                    className={cn(styles.block7, styles.block7_layout)}
                    style={{ cursor: "pointer", marginRight: "15px" }}
                  >
                    <h5
                      className={cn(
                        styles.highlights1,
                        styles.highlights1_layout
                      )}
                    >
                      {"Back"}
                    </h5>
                  </div>
                </Link>
              </div>
              {/* <div className={cn(styles.flex9_item)}>
                <div
                  onClick={reset}
                  className={cn(styles.block7, styles.block7_layout)}
                  style={{ cursor: "pointer" }}
                >
                  <h5
                    className={cn(
                      styles.highlights1,
                      styles.highlights1_layout
                    )}
                  >
                    {"Cancel"}
                  </h5>
                </div>
              </div> */}
              {/* <div className={cn(styles.flex9_spacer)} /> */}
              <div className={cn(styles.flex9_item)}>
                <div
                  onClick={handleSubmit}
                  className={cn(styles.block8, styles.block8_layout)}
                  style={{ cursor: "pointer" }}
                >
                  <h5
                    className={cn(
                      styles.highlights2,
                      styles.highlights2_layout
                    )}
                  >
                    {"Submit"}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default function PriceListAdd(props) {
  return (
    <>
      <Master opts={props} screen={AddPriceList} showStatus={false} />
    </>
  );
}
